import React from 'react';

import parse from 'html-react-parser';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonSmallTitle from '../../../common-components/common-small-title';
import CommonSmallText from '../../../common-components/common-small-text';

const taskPointList = [
    {
        img: '/images/svg/krdv/krdv-complex__point-img1.svg',
        title: 'Интеграция',
        text: 'Самое сложное в&nbsp;проекте&nbsp;&mdash; интеграция с&nbsp;банками для получения финансирования проекта. У&nbsp;Сбербанка, например, несколько регионов, в&nbsp;каждом несколько отделений, в&nbsp;котором несколько сотрудников. Каждому сотруднику нужно было разграничить доступы, чтобы, к&nbsp;примеру, Хабаровский край не&nbsp;смотрел заявки Амурской области.',
    },
    {
        img: '/images/svg/krdv/krdv-complex__point-img2.svg',
        title: 'Матрица банков',
        text: 'Еще у&nbsp;каждого банка свои процентные ставки по&nbsp;кредитам и&nbsp;условия выдачи кредитов. Система не&nbsp;должна врать, ее&nbsp;задача предоставить пользователю актуальную информацию. Для этого мы&nbsp;составляли матрицу банков&nbsp;&mdash; расписывали все условия и&nbsp;создавали конструктор. Сначала нужно ответить на&nbsp;несколько вопросов, в&nbsp;ходе ответов на&nbsp;которые система убирает лишние варианты и&nbsp;оставляет самые подходящие.',
    },
    {
        img: '/images/svg/krdv/krdv-complex__point-img3.svg',
        title: 'Отсутствие аналогов',
        text: 'Система не&nbsp;имеет аналогов. Мы&nbsp;сделали функционал, который не&nbsp;существовал в&nbsp;России. Было много тестирований пользовательского пути. Чтобы было эффективно, удобно и&nbsp;просто.',
    },
];

const Complex = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper className="krdv-complex">
                <div className="krdv-complex__wrapper">
                    <div className="krdv-complex__grid">
                        <CommonTitle className="krdv-complex__title">Сложности</CommonTitle>
                        <div className="krdv-complex__points">
                            {taskPointList.map(({ img, title, text }, index) => (
                                <ScrollAnimation
                                    animateIn="fadeIn"
                                    offset={50}
                                    animateOnce={true}
                                    duration={1}
                                    className="krdv-complex__point-item"
                                    key={index}
                                >
                                    <div className="krdv-complex__point-title">
                                        <img
                                            className="krdv-complex__point-img"
                                            src={img}
                                            alt=""
                                            loading="lazy"
                                        />
                                        <CommonSmallTitle>{parse(title)}</CommonSmallTitle>
                                    </div>
                                    <CommonSmallText className="krdv-complex__point-text">
                                        {parse(text)}
                                    </CommonSmallText>
                                </ScrollAnimation>
                            ))}
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Complex;
